// put this in resources/assets/js

(function($){

    $(function(){
        'use strict';


        var FieldGroup = function($obj, fieldTypesText, inc) {
            this.$obj = $obj;
            this.fieldTypesText = fieldTypesText;
            this.inc = (typeof inc === 'undefined') ? 0 : inc;
        };
        FieldGroup.prototype = {
            init: function() {
                this.$obj.find('.add-field').on('click', this.addFieldTemplateHandler.bind(this));
                this.$obj.on('click', '.delete-field', this.deleteFieldTemplateHandler.bind(this));
            },
            getTemplate: function() {
                var fieldTemplate = [];
                fieldTemplate.push('<li class="field-template">');
                fieldTemplate.push('<select name="fieldgroups[group_field_' + this.inc + '][type]">' + this.fieldTypesText +'</select> ');
                fieldTemplate.push(' <input type="text" name="fieldgroups[group_field_' + this.inc + '][name]" style="width: 200px;" placeholder="field name">');
                fieldTemplate.push(' <input type="text" name="fieldgroups[group_field_' + this.inc + '][attribs]" placeholder="field attribs">');
                fieldTemplate.push(' <input type="text" name="fieldgroups[group_field_' + this.inc + '][description]" placeholder="field description">');
                fieldTemplate.push(' <input type="text" name="fieldgroups[group_field_' + this.inc + '][order]" style="width: 50px;" placeholder="order">');
                fieldTemplate.push(' <button class="delete-field btn btn-danger-outline"><i class="fa fa-times" data-placement="top"></i></button>');
                fieldTemplate.push('</li>');
                return fieldTemplate.join('');
            },
            addFieldTemplateHandler: function(e) {
                e.preventDefault();
                this.inc+=1;
                this.$obj.find('.added-fields').append(this.getTemplate());
            },
            deleteFieldTemplateHandler: function(e) {
                e.preventDefault();
                $(e.target).parents('li').remove();
                this.inc-=1;
            }
        }

        $('[class*=form-fieldgroup]').each(function() {
            (new FieldGroup(
                $(this),
                fieldTypesText,
                $(this).find('.field-template').length-1
            )).init();
        });
    });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/fieldgroups.js